// packages/shared/src/tutorial/tutorial-ids.ts
/**
 * 전 튜토리얼 완료 ID 단일 소스. 서버 markCompleted allowlist + 클라 레지스트리가 공유.
 * 값은 영구 — 변경 시 기존 completedTutorials 와 불일치.
 */
export const TUTORIAL_IDS = {
  STAGE_ENTRY: 'TUT_STAGE_ENTRY',
  TUT1: 'TUT1',
  TUT2: 'TUT2',
  TUT2_SYNERGY: 'TUT2_SYNERGY',
  /** 스테이지2 1웨이브 상점 — 전설 등급 무기 구매 안내. */
  TUT2_LEGENDARY: 'TUT2_LEGENDARY',
  /** 펫 소환 아이템이 처음 등장하는 상점(스테이지3~) — 설명만, 구매 강제 없음. */
  TUT2_PET_ITEM: 'TUT2_PET_ITEM',
  TUT3: 'TUT3',
  TUT4: 'TUT4',
  PET_EQUIP: 'PET_EQUIP',
  TUT_DEGEN: 'TUT_DEGEN',
  TUT_IDLE: 'TUT_IDLE',
  TUT5: 'TUT5',
  TUT6: 'TUT6',
  TUT7: 'TUT7',
  TUT_COLLECTION: 'TUT_COLLECTION',
} as const;

export type TutorialId = (typeof TUTORIAL_IDS)[keyof typeof TUTORIAL_IDS];

export const ALL_TUTORIAL_IDS: readonly TutorialId[] = Object.values(TUTORIAL_IDS);

export function isValidTutorialId(id: unknown): id is TutorialId {
  return typeof id === 'string' && (ALL_TUTORIAL_IDS as readonly string[]).includes(id);
}
